import { render } from "./PublicationMultimedia.vue?vue&type=template&id=632e4638&scoped=true"
import script from "./PublicationMultimedia.vue?vue&type=script&lang=js"
export * from "./PublicationMultimedia.vue?vue&type=script&lang=js"

import "./PublicationMultimedia.vue?vue&type=style&index=0&id=632e4638&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632e4638"]])

export default __exports__